"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Periodo = void 0;
var Periodo = /** @class */ (function () {
    function Periodo(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.NUM_PER, NUM_PER = _c === void 0 ? '' : _c, _d = _a.ANO_PER, ANO_PER = _d === void 0 ? '' : _d, _e = _a.DATA_REM, DATA_REM = _e === void 0 ? '' : _e;
        this._id = _id;
        this.NUM_PER = NUM_PER;
        this.ANO_PER = ANO_PER;
        this.DATA_REM = DATA_REM;
    }
    return Periodo;
}());
exports.Periodo = Periodo;
//# sourceMappingURL=Periodo.js.map